module.exports = __webpack_public_path__ + "img/item6.22109816.png";